import React from "react";
import { Switch } from "@material-ui/core";
import { Form, Col, Row } from "react-bootstrap";

export function ReceiptOfPaymentForm({ 
  handleChange,
  values
 }) {
  const receiptOfPaymentOrderNo = values.receiptOfPaymentOrderNo != null ? values.receiptOfPaymentOrderNo : "";
  const receiptOfPaymentOrderNoNext = values.receiptOfPaymentOrderNoNext != null ? values.receiptOfPaymentOrderNoNext : "";

  return (
    <>
      <Form.Group as={Row} controlId="receiptOfPaymentOrderNo">
        <Form.Label column sm={4}>
          Tahsilat Makbuzu Sıra No
        </Form.Label>
        <Col sm={8}>
          <Form.Control type="number" min={1} value={receiptOfPaymentOrderNo} placeholder="Tahsilat Makbuzu Sıra No" onChange={handleChange} />
        </Col>
      </Form.Group>
                      
      <Form.Group as={Row} controlId="receiptOfPaymentOrderNoNext">
        <Form.Label column sm={4}>
          Sıradaki
        </Form.Label>
        <Col sm={8}>
          <Form.Control value={receiptOfPaymentOrderNoNext} placeholder="Sıradaki" readOnly />
        </Col>
      </Form.Group>

      <Form.Group as={Row} controlId="accountingManager">
        <Form.Label column sm={4}>
          Muhasebe Müdürü
        </Form.Label>
        <Col sm={8}>
          <Form.Control type="text" value={values.accountingManager} placeholder="Muhasebe Müdürü" onChange={handleChange} />
        </Col>
      </Form.Group>

      <Form.Group as={Row} controlId="isAccountingPersonnelAdded">
        <Form.Label column sm={4}>
          Tahsil Eden Personeli Makbuza Ekle
        </Form.Label>
        <Col sm={8}>
          <Switch checked={values.isAccountingPersonnelAdded} onChange={handleChange("isAccountingPersonnelAdded")} />
        </Col>
      </Form.Group>
    </>        
  );
}